import * as tslib_1 from "tslib";
import { SortIndicatorStyle_$type } from "./SortIndicatorStyle";
import { ColumnOptionsIconAlignment_$type } from "./ColumnOptionsIconAlignment";
import { ColumnOptionsIconBehavior_$type } from "./ColumnOptionsIconBehavior";
import { IgrTextCellInfo } from "./igr-text-cell-info";
import { TextHeaderCellModel as TextHeaderCellModel_internal } from "./TextHeaderCellModel";
import { ensureBool, ensureEnum, brushToString, stringToBrush } from "igniteui-react-core";
/**
 * Backing information for a text header cell.
*/
var IgrTextHeaderCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTextHeaderCellInfo, _super);
    function IgrTextHeaderCellInfo() {
        return _super.call(this) || this;
    }
    IgrTextHeaderCellInfo.prototype.createImplementation = function () {
        return new TextHeaderCellModel_internal();
    };
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "isColumnOptionsEnabled", {
        /**
         * Sets or gets whether the filter UI should be visible in the header.
        */
        get: function () {
            return this.i.kq;
        },
        set: function (v) {
            this.i.kq = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "sortIndicatorStyle", {
        get: function () {
            return this.i.ko;
        },
        set: function (v) {
            this.i.ko = ensureEnum(SortIndicatorStyle_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconAlignment", {
        /**
         * Gets or sets the alignment of the column options icon within the header cell.
        */
        get: function () {
            return this.i.kk;
        },
        set: function (v) {
            this.i.kk = ensureEnum(ColumnOptionsIconAlignment_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconColor", {
        /**
         * Gets or sets the color for the column options icon in the header.
        */
        get: function () {
            return brushToString(this.i.k2);
        },
        set: function (v) {
            this.i.k2 = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconBehavior", {
        /**
         * Gets or sets how the column option icon will behave in the header.
        */
        get: function () {
            return this.i.km;
        },
        set: function (v) {
            this.i.km = ensureEnum(ColumnOptionsIconBehavior_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrTextHeaderCellInfo;
}(IgrTextCellInfo));
export { IgrTextHeaderCellInfo };
//# sourceMappingURL=igr-text-header-cell-info.js.map
